module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"groups":{"removeParticipant":"Remove from this group"},"tooltips":{"restrictedContactActions":"This contact is managed by your Enterprise"}},"es":{"groups":{"removeParticipant":"Eliminar de este grupo"},"tooltips":{"restrictedContactActions":"Este contacto esta manejado por tu Empresa"}}}')
  delete Component.options._Ctor
}
